
import Input from '@/ui-kit/components/input';
import { StyleFillType } from '@/ui-kit/components/input/enums';
import { InputEventTypes, InputLabels, InputLengths } from '../enums';
import InputErrorHandler from '../mixins/InputErrorHandler';
import InputCommonValidators from '../mixins/InputValidators';
import { MaxLengthErrorMessage } from '@/components/inputs/constants';

export default {
  name: 'NameInput',
  components: {
    Input,
  },
  mixins: [InputErrorHandler, InputCommonValidators],
  props: {
    className: {
      default: '',
      type: String,
    },
    value: {
      default: '',
      type: String,
    },
    isShowErrorMessage: {
      default: false,
      type: Boolean,
    },
    errorMessage: {
      default: '',
      type: String,
    },
    placeholder: {
      default: '',
      type: String,
    },
    fillType: {
      default: StyleFillType.Outlined,
      type: String,
    },
  },
  data() {
    return {
      InputLabels,
    };
  },
  methods: {
    handleChange(value) {
      this.$emit(InputEventTypes.Change, value);

      this.handleErrors(value);
    },
    handleBlur(value) {
      this.handleErrors(value);
    },
    handleErrors(value) {
      this.handleErrorChange(value, [
        this.validateIsRequired,
        this.validateLength,
      ]);
    },
    validateLength(value) {
      const isError = value.length > InputLengths.Name;

      return this.getErrorObject(isError, `${MaxLengthErrorMessage} ${InputLengths.Name} characters`);
    },
  },
};
